<template>
  <div class="customer-vehicles" v-if="customer">
    <vehicle-list :customer-id="customer.id" :customer-name="customer.firstname + ' ' + customer.lastname" />
  </div>
</template>

<script>
import VehicleList from "@/components/elements/VehicleList.vue";

export default {
  components: { VehicleList },

  computed: {
    customer() {
      return this.$parent.customer ?? null
    },
  },
}
</script>

<style lang="scss">
</style>
